import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faWarning} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";
function AuthFailed(){
    return (
        <main className='main'>
            <div className='container'>
                <div className='row flex-center auth-wrapper py-5'>
                    <div className='col-sm-10 col-md-8 col-lg-5 col-xl-5 col-xxl-3'>
                        <div className="px-xxl-5">
                            <div className="text-center mb-6">
                                <div className="mb-3">
                                    <div className="d-flex flex-column align-items-center mb-3">
                                        <FontAwesomeIcon className="text-danger fw-bold fs-4" icon={faWarning} />
                                        <span className="fs-7 fw-bold mt-2">Oops!</span>
                                    </div>
                                    <h4 className="mb-3 text-danger">Authentication Failed - Forbidden</h4>
                                    <p className="text-body-tertiary fs-8-1 mb-1">You do not have the required permission or authentication to perform the selected operation.</p>
                                </div>
                                <p className="fs-8-1">
                                    Please try navigating using the options below.
                                </p>
                                <p>
                                    <Link className="w-100 mb-3 fs-9 fw-bold " to="/auth/signin">
                                        <FontAwesomeIcon className="me-2" icon={faChevronLeft}/>Go to Signin page
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className='text-center'>
                <span className="fs-9 pe-3">©2025 BreakThrough, Inc. All rights reserved.</span>
                <Link className="fs-9 fw-semibold pe-3" to="/home">Terms of use</Link>
                <Link className="fs-9 fw-semibold" to="/home">Privacy policy</Link>
            </footer>
        </main>
    )
}
export default AuthFailed;